var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetrieve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -2048 2055 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1, -1) rotate(90) translate(0 -2048)",
    d: "M384 1792h128v-1536h-128v1536zM1856 1024l-1088 -768v1536zM896 503l738 521l-738 521v-1042z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetrieve);
export default __webpack_public_path__ + "static/media/Retrieve.b520d312.svg";
export { ForwardRef as ReactComponent };